import { Chip, styled } from "@mui/material";
import { getTextContrastColor } from "utils/textContrastColor";

const LabelChipUnstyled = ({ label, color, onDelete, className }) => {
  return (
    <Chip
      label={label}
      size="small"
      onDelete={onDelete}
      sx={{
        backgroundColor: `${color}`,
        color: getTextContrastColor(color),
        "& .MuiChip-deleteIcon": {
          color: getTextContrastColor(color),
          "&:hover": {
            color: getTextContrastColor(color),
          },
        },
      }}
      className={className}
    />
  );
};

const LabelChip = styled(LabelChipUnstyled)({});
export default LabelChip;
